export default __webpack_public_path__ + "static/media/arrow_down.9ea0edf9.svg";